angular.module('TetherApp').factory(
    'surveyService',
    [
        '$http',
        function ($http) {

            let randomString = function randomString(length, chars) {
                let result = '';
                for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
                return result;
            };

            let indexSurvey = function (page) {
                let uri = '/api/v1/experience/survey/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                if (page != undefined) {
                    uri += '?page=' + page;
                }
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let storeSurvey = function (data) {
                return $http.post(
                    '/api/v1/experience/survey',
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let updateSurvey = function (data) {
                let uri = '/api/v1/experience/survey/' + data.experience.eid;
                return $http.put(
                    uri,
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let deleteSurvey = function (surveyId) {
                let uri = '/api/v1/experience/survey/' + surveyId + '/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                return $http.delete(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            // START: REPORTING
            let getReport = function (validateUploadId, parameters) {
                let uri = '/api/v1/experience/survey/' + validateUploadId + '/get-report/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' },
                        params: parameters
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let reportRegenerate = function (clientEid, experienceEid) {
                return $http.post('/' + clientEid + '/api/survey/' + experienceEid + '/report-regeneration', {}, {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }).then(function (response) {
                    return response.data;
                });
            };
            // END: REPORTING

            let statsSurvey = function (surveyId) {
                let uri = '/api/v1/experience/survey/' + surveyId + '/get-report/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    )
                    + '?report_name=stats&report_type=json';
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            return {
                indexSurvey: indexSurvey,
                storeSurvey: storeSurvey,
                updateSurvey: updateSurvey,
                deleteSurvey: deleteSurvey,
                reportRegenerate: reportRegenerate,
                statsSurvey: statsSurvey,
                getReport: getReport
            };

        }
    ]
);
